import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"

interface CertFormFieldsProps {
  formData: {
    domain: string
    name: string
    type: string
    email: string
  }
  recordNumber: string
  onChange: (field: string, value: string) => void
}

export const CertFormFields = ({ formData, recordNumber, onChange }: CertFormFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="domain" className="text-gray-200">认证域名</Label>
        <Input 
          id="domain" 
          value={formData.domain}
          onChange={(e) => onChange('domain', e.target.value)}
          required 
          className="bg-white/5 border-white/10 text-white placeholder:text-gray-400"
          placeholder="请输入域名"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="recordNumber" className="text-gray-200">认证号码</Label>
        <div className="flex items-center gap-2">
          <img 
            src="/lovable-uploads/f811e6b5-3b53-4a2c-b797-9f76cecaa442.png" 
            alt="认证图标" 
            className="w-6 h-6"
          />
          <Input 
            id="recordNumber" 
            value={recordNumber}
            readOnly
            className="bg-white/5 border-white/10 text-white font-mono"
          />
        </div>
        <p className="text-sm text-gray-400">自动生成的认证号码</p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="name" className="text-gray-200">申请人/企业名称</Label>
        <Input 
          id="name" 
          value={formData.name}
          onChange={(e) => onChange('name', e.target.value)}
          className="bg-white/5 border-white/10 text-white placeholder:text-gray-400"
          placeholder="请输入名称（可选）"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-gray-200">申请类型</Label>
        <RadioGroup
          value={formData.type}
          onValueChange={(value) => onChange('type', value)}
          className="flex space-x-4"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="personal" id="personal" />
            <Label htmlFor="personal" className="text-gray-200">个人</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="business" id="business" />
            <Label htmlFor="business" className="text-gray-200">企业</Label>
          </div>
        </RadioGroup>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="email" className="text-gray-200">邮箱地址</Label>
        <Input 
          id="email" 
          type="email" 
          value={formData.email}
          onChange={(e) => onChange('email', e.target.value)}
          required 
          className="bg-white/5 border-white/10 text-white placeholder:text-gray-400"
          placeholder="请输入邮箱地址"
        />
        <p className="text-sm text-gray-400">认证号码将发送到此邮箱</p>
      </div>
    </>
  )
}